import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-ar-wvat-knockoff',
  templateUrl: './wvat-knockoff.component.html',
  styles: [],
  standalone: false
})
export class ARWVatKnockoffComponent implements OnInit {
  constructor(private fb: FormBuilder) {}

  private _observeChanges = false;
  @Input() data: any[] = [];
  visible = false;
  form = this.fb.group({
    details: this.fb.array([this.createLine()])
  });
  get details() {
    return this.form.controls.details;
  }
  ngOnInit(): void {
    let count = this.data?.length ?? 0;
    this.details.clear();
    this._observeChanges = false;
    for (let i = 0; i < count; i++) {
      let line = this.createLine();
      line.patchValue(this.data[i]);
      this.details.push(line);
    }
    this._observeChanges = true;
  }

  handleOk() {}
  handleCancel() {}

  addLine() {
    this.details.push(this.createLine());
  }

  removeLine(index: number) {
    this.details.removeAt(index);
  }

  get totalWVatAmount() {
    let total = 0;
    this.details.value.forEach(item => {
      total += <number>item.wVatAmount;
    });
    return total;
  }

  private createLine() {
    const line = this.fb.group({
      wVatCodeId: [<any>null, []],
      wVatCode: [<any>null, [Validators.required]],
      paymentAmount: [0, []],
      wVatAmount: [<number>0, []]
    });

    line.controls.paymentAmount.valueChanges.subscribe(val => {
      if (!this._observeChanges) return;

      this._observeChanges = false;
      line.value.paymentAmount = val;
      this.recalculate(line);
      this._observeChanges = true;
    });
    line.controls.wVatCode.valueChanges.subscribe(val => {
      if (!this._observeChanges) return;
      this._observeChanges = false;
      line.controls.wVatCodeId.setValue(val?.id);
      this.recalculate(line);
      this._observeChanges = true;
    });

    return line;
  }

  private recalculate(line: FormGroup) {
    let rate = 0;
    let amount = 0;
    if (line.controls['wVatCode'].value) {
      rate = line.controls['wVatCode'].value.rate;
    }
    if (line.controls['paymentAmount'].value) {
      amount = line.controls['paymentAmount'].value;
    }

    const wvatAmount = Math.round(rate * amount * 100) / 100;

    line.controls['wVatAmount'].setValue(wvatAmount);
  }
}
